export const MOCK_CITIES_BY_PROVINCE = [
  { city: "Agliè", id: 1 },
  { city: "Airasca", id: 2 },
  { city: "Ala di Stura", id: 3 },
  { city: "Albiano d'Ivrea", id: 4 },
  { city: "Almese", id: 5 },
  { city: "Alpette", id: 6 },
  { city: "Alpignano", id: 7 },
  { city: "Andezeno", id: 8 },
  { city: "Andrate", id: 9 },
  { city: "Angrogna", id: 10 },
  { city: "Arignano", id: 11 },
  { city: "Avigliana", id: 12 },
  { city: "Azeglio", id: 13 },
  { city: "Bairo", id: 14 },
  { city: "Balangero", id: 15 },
  { city: "Baldissero Canavese", id: 16 },
  { city: "Baldissero Torinese", id: 17 },
  { city: "Balme", id: 18 },
  { city: "Banchette", id: 19 },
  { city: "Barbania", id: 20 },
  { city: "Bardonecchia", id: 21 },
  { city: "Barone Canavese", id: 22 },
  { city: "Beinasco", id: 23 },
  { city: "Bibiana", id: 24 },
  { city: "Bobbio Pellice", id: 25 },
  { city: "Bollengo", id: 26 },
  { city: "Borgaro Torinese", id: 27 },
  { city: "Borgiallo", id: 28 },
  { city: "Borgofranco d'Ivrea", id: 29 },
  { city: "Borgomasino", id: 30 },
  { city: "Borgone Susa", id: 31 },
  { city: "Bosconero", id: 32 },
  { city: "Brandizzo", id: 33 },
  { city: "Bricherasio", id: 34 },
  { city: "Brosso", id: 35 },
  { city: "Brozolo", id: 36 },
  { city: "Bruino", id: 37 },
  { city: "Brusasco", id: 38 },
  { city: "Bruzolo", id: 39 },
  { city: "Buriasco", id: 40 },
  { city: "Burolo", id: 41 },
  { city: "Busano", id: 42 },
  { city: "Bussoleno", id: 43 },
  { city: "Buttigliera Alta", id: 44 },
  { city: "Cafasse", id: 45 },
  { city: "Caluso", id: 46 },
  { city: "Cambiano", id: 47 },
  { city: "Campiglione Fenile", id: 48 },
  { city: "Candia Canavese", id: 49 },
  { city: "Candiolo", id: 50 },
  { city: "Canischio", id: 51 },
  { city: "Cantalupa", id: 52 },
  { city: "Cantoira", id: 53 },
  { city: "Caprie", id: 54 },
  { city: "Caravino", id: 55 },
  { city: "Carema", id: 56 },
  { city: "Carignano", id: 57 },
  { city: "Carmagnola", id: 58 },
  { city: "Casalborgone", id: 59 },
  { city: "Cascinette d'Ivrea", id: 60 },
  { city: "Caselette", id: 61 },
  { city: "Caselle Torinese", id: 62 },
  { city: "Castagneto Po", id: 63 },
  { city: "Castagnole Piemonte", id: 64 },
  { city: "Castellamonte", id: 65 },
  { city: "Castelnuovo Nigra", id: 66 },
  { city: "Castiglione Torinese", id: 67 },
  { city: "Cavagnolo", id: 68 },
  { city: "Cavour", id: 69 },
  { city: "Cercenasco", id: 70 },
  { city: "Ceres", id: 71 },
  { city: "Ceresole Reale", id: 72 },
  { city: "Cesana Torinese", id: 73 },
  { city: "Chialamberto", id: 74 },
  { city: "Chianocco", id: 75 },
  { city: "Chiaverano", id: 76 },
  { city: "Chieri", id: 77 },
  { city: "Chiesanuova", id: 78 },
  { city: "Chiomonte", id: 79 },
  { city: "Chiusa di San Michele", id: 80 },
  { city: "Chivasso", id: 81 },
  { city: "Ciconio", id: 82 },
  { city: "Cintano", id: 83 },
  { city: "Cinzano", id: 84 },
  { city: "Ciriè", id: 85 },
  { city: "Claviere", id: 86 },
  { city: "Coassolo Torinese", id: 87 },
  { city: "Coazze", id: 88 },
  { city: "Collegno", id: 89 },
  { city: "Colleretto Castelnuovo", id: 90 },
  { city: "Colleretto Giacosa", id: 91 },
  { city: "Condove", id: 92 },
  { city: "Corio", id: 93 },
  { city: "Cossano Canavese", id: 94 },
  { city: "Cuceglio", id: 95 },
  { city: "Cumiana", id: 96 },
  { city: "Cuorgnè", id: 97 },
  { city: "Druento", id: 98 },
  { city: "Exilles", id: 99 },
  { city: "Favria", id: 100 },
  { city: "Feletto", id: 101 },
  { city: "Fenestrelle", id: 102 },
  { city: "Fiano", id: 103 },
  { city: "Fiorano Canavese", id: 104 },
  { city: "Foglizzo", id: 105 },
  { city: "Forno Canavese", id: 106 },
  { city: "Frassinetto", id: 107 },
];
